import { useAppQuery } from '@/helpers/api/query'

import { createInstance } from '@/helpers/api/base'
import { LogSuggestions } from '@/types/reader'

const GET_LOG_SUGGESTIONS_KEY = 'GET_LOG_SUGGESTIONS'

export const useGetLogSuggestions = () =>
    useAppQuery<LogSuggestions>({
        queryKey: [GET_LOG_SUGGESTIONS_KEY],
        queryFn: () =>
            createInstance({
                url: '/hubs/suggestions',
                method: 'GET',
            }),
        staleTime: Infinity,
    })
